// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__15VZR","list":"styles_list__13Sg6"};